module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "text-center py-3 bold",
    domProps: {
      "innerHTML": _vm._s(_vm.info.title)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.message)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('button', {
    staticClass: "btn action wide w-100",
    on: {
      "click": _vm.clickedOk
    }
  }, [_vm._v("OK")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-74a380c0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74a380c0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/richPrompt/templates/default.vue
// module id = 1457
// module chunks = 0